import {boolean} from '../types'
import {mergeConfig} from '../../configStore'
import type {CheckboxField, FieldReturn} from '../../types'

const defaultProps: Partial<CheckboxField> = {
  options: {
    layout: 'checkbox',
  },
}

export const checkbox = (props?: CheckboxField, mergeProps?: Partial<CheckboxField>): FieldReturn =>
  boolean(mergeConfig('checkbox', props, mergeProps, defaultProps))
